var indexOf = [].indexOf;

angular.module('app.controllers').controller('HomeCtrl', ['$scope', 'APIPrograms', 'APIRead2', '$rootScope'].append(function(self, APIPrograms, APIRead2, root) {
  var mday, ref;
  self.days = ['01', '02.10.2024', '03.10.2024', '04.10.2024', '05.10.2024'];
  self.day = parseInt(self.get('day')) || null;
  mday = moment().format('DD.MM.YYYY');
  if ((self.day == null) || (ref = self.day, indexOf.call([1, 2, 3, 4], ref) < 0)) {
    self.day = indexOf.call(self.days, mday) >= 0 ? self.days.indexOf(mday) : 1;
  }
  return APIRead2.query({
    entry_type: 'program_highlights',
    da: self.day,
    limit: 120
  }, function(data) {
    return self.programs = data;
  });
}));
